import { ExtraSmallIcon, XClose } from "@nova/component-icons"
import { useTranslation } from "@nova/use-translation"

export const SearchTag = ({ title, onClick }: { title: string; onClick: () => void }) => {
    const { t } = useTranslation()

    return (
        <div className="pl-2 pr-1 h-5 flex items-center gap-1 bg-gray-700 rounded-lg whitespace-nowrap">
            <small className="text-gray-0">{t(title)}</small>
            <ExtraSmallIcon
                Icon={XClose}
                className="text-gray-100 cursor-pointer hover:text-gray-0"
                onClick={onClick}
            />
        </div>
    )
}
